import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { OBSTACLE_LIGHTING_FALLBACK, OBSTACLE_MARKING_FALLBACK, TEST_ID } from './constants';
import type { AirspaceObstacle, FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const buildTitle = (obstacle: AirspaceObstacle): string => `Obstacle (${obstacle.obstacleType})`;

const buildSubtitle = (obstacle: AirspaceObstacle): string => {
    const lighting = obstacle.lighting ?? OBSTACLE_LIGHTING_FALLBACK;
    const marking = obstacle.marking ?? OBSTACLE_MARKING_FALLBACK;

    return `${obstacle.heightFt.toLocaleString()} ft — lighting: ${lighting}; marking: ${marking}`;
};

const ObstacleCard: FunctionComponent<Props> = ({ className = '', obstacle, testId = TEST_ID }) => {
    const title = buildTitle(obstacle);
    const subtitle = buildSubtitle(obstacle);

    return (
        <HorizontalContainer className={`${styles.card} ${className}`} testId={testId}>
            <Wrapper className={styles.severityStripe} />

            <VerticalContainer className={styles.content}>
                <Wrapper className={styles.title}>{title}</Wrapper>

                <Wrapper className={styles.subtitle}>{subtitle}</Wrapper>
            </VerticalContainer>
        </HorizontalContainer>
    );
};

export default ObstacleCard;
